<div id="filter-head">
    <div>
        <button
            mat-button
            id="filter-button"
            class="filter-button"
            *ngIf="showFilterButton && !readonly"
            (click)="filterButtonClick($event)"
        >
            <mat-icon
                id="filter-head-icon"
                matListItemGraphic
                fontSet="fas"
                fontIcon="fa-sliders-h"
                inline
            ></mat-icon
            >Filter
        </button>
        <div class="main-filter-option-container">
            <div class="main-filter-option-area" *ngIf="isSaveFilterDialogOpen">
                <mat-card class="filter-option-card" (mouseleave)="filterMouseLeaveEvent()">
                    <div class="filter-container">
                        <div id="save-filter-title" class="filter-title">
                            Save Filter
                            <span class="warning-message">{{ filterSavedErrorMsg }}</span>
                        </div>
                        <div *ngIf="showSaveAsSelectedFiltersOptions()">
                            <mat-radio-group
                                [(ngModel)]="filterSaveAsMethod"
                                (change)="checkSaveFilterDialogBtnStatus()"
                            >
                                <div class="radio-button-container">
                                    <mat-radio-button [value]="'overrideExisting'"
                                        >Save as:
                                        {{ getSelectedSavedFilterName() }}</mat-radio-button
                                    >
                                </div>
                                <div class="radio-button-container">
                                    <mat-radio-button [value]="'saveAsNew'"
                                        >Save as a new name</mat-radio-button
                                    >
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="filter-ddl">
                            <mat-form-field
                                class="save-filter-form-field"
                                appearance="outline"
                                *ngIf="saveAsNewFilter"
                            >
                                <input
                                    matInput
                                    placeholder="Enter name"
                                    [(ngModel)]="filterSaveText"
                                    type="text"
                                    (ngModelChange)="checkSaveFilterDialogBtnStatus()"
                                />
                            </mat-form-field>
                        </div>
                        <div class="button-sets" id="save-cancel-buttons">
                            <button
                                mat-button
                                id="save-filter-button"
                                class="save-button"
                                (click)="cancelSaveFilters()"
                            >
                                Cancel
                            </button>
                            <button
                                mat-button
                                class="apply-button"
                                id="apply-filter-button"
                                (click)="saveSelectedFilters()"
                                [disabled]="isSaveFilterDialogBtnDisabled"
                            >
                                SAVE
                            </button>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>

        <div class="main-filter-option-container">
            <div
                class="main-filter-option-area"
                id="main-filter-option-area"
                *ngIf="isFilterDialogOpen"
            >
                <mat-card class="filter-option-card" (mouseleave)="filterMouseLeaveEvent()">
                    <div class="filter-container">
                        <div id="main-filter-title" class="filter-title">Filter Dashboard</div>
                        <div
                            id="saved-filter-ddl"
                            class="filter-ddl"
                            *ngIf="savedFilters.length > 0"
                        >
                            <angular2-multiselect
                                [data]="savedFilters"
                                [(ngModel)]="selectedSavedFilters"
                                [settings]="settingsSavedFilters"
                                (onSelect)="onItemSelectSavedFilters($event)"
                                (onDeSelect)="onItemDeSelectSavedFilters($event)"
                                (onSelectAll)="onSelectAll($event)"
                                (onDeSelectAll)="onDeSelectAll($event)"
                                (onOpen)="
                                    setContainerHeight(
                                        'saved-filter-ddl',
                                        true,
                                        savedFilters !== null ? savedFilters.length : 0,
                                        settingsSavedFilters.enableSearchFilter
                                    )
                                "
                                (onClose)="setContainerHeight('saved-filter-ddl', false, 0)"
                            >
                                <c-item>
                                    <ng-template let-item="item">
                                        <label>{{ item.filterName }}</label>
                                        <i
                                            class="far fa-trash-alt saved-delete-icon"
                                            (click)="savedItemDelete(item)"
                                            title="Delete"
                                        ></i>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                        <div id="sub-filter-title-filter-by" class="sub-filter-title">
                            Filter By
                        </div>
                        <div
                            id="filter-by-ddl"
                            class="filter-ddl"
                            [style.pointer-events]="locationPointerEvent"
                        >
                            <angular2-multiselect
                                [data]="locationFilterItems"
                                [(ngModel)]="selectedLocations"
                                [settings]="settingsLocations"
                                (onSelect)="onMainFilterChange($event)"
                                (onDeSelect)="onMainFilterChange($event)"
                                (onSelectAll)="onSelectAll($event)"
                                (onDeSelectAll)="onDeSelectAll($event)"
                                (onOpen)="
                                    setContainerHeight(
                                        'filter-by-ddl',
                                        true,
                                        locationFilterItems !== null
                                            ? locationFilterItems.length
                                            : 0,
                                        settingsLocations.enableSearchFilter
                                    )
                                "
                                (onClose)="setContainerHeight('filter-by-ddl', false, 0)"
                            >
                            </angular2-multiselect>
                        </div>
                        <!--TODO: Remove or optimize repitision code; add a function to get repition code from one place-->
                        <div id="filter-middle-container">
                            <div *ngFor="let item of selectedLocations">
                                <div
                                    id="sub-filter-{{ item.roleName }}"
                                    class="sub-filter"
                                    *ngIf="
                                        !item.isHidden && !item.isEmployee && !item.isStaffPosition
                                    "
                                    [style.pointer-events]="item.disableStatus"
                                >
                                    <div class="sub-filter-title">
                                        {{ convertToCamelcase(item.roleNameDisplay) }}
                                    </div>
                                    <angular2-multiselect
                                        [data]="
                                            item.roleItemArray !== null ? item.roleItemArray : []
                                        "
                                        [(ngModel)]="item.roleSelectedItemArray"
                                        [settings]="item.settings"
                                        (onSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-' + item.roleName
                                            )
                                        "
                                        (onDeSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-' + item.roleName
                                            )
                                        "
                                        (onSelectAll)="onSelectAll($event)"
                                        (onDeSelectAll)="onDeSelectAll($event)"
                                        (onFilterSelectAll)="onSelectAll($event)"
                                        (onFilterDeSelectAll)="onDeSelectAll($event)"
                                        (onOpen)="
                                            setContainerHeight(
                                                'sub-filter-' + item.roleName,
                                                true,
                                                item.roleItemArray !== null
                                                    ? item.roleItemArray.length
                                                    : 0,
                                                item.settings.enableSearchFilter,
                                                item.settings.enableCheckAll
                                            )
                                        "
                                        (onClose)="
                                            setContainerHeight(
                                                'sub-filter-' + item.roleName,
                                                false,
                                                0
                                            )
                                        "
                                    >
                                    </angular2-multiselect>
                                </div>
                                <div
                                    id="sub-filter-staff-position"
                                    class="sub-filter"
                                    *ngIf="
                                        !item.isHidden && item.isEmployee && item.isStaffPosition
                                    "
                                    [style.pointer-events]="item.disableStatus"
                                >
                                    <div class="sub-filter-title">Position</div>
                                    <angular2-multiselect
                                        [data]="
                                            item.staffPositionArray !== null
                                                ? item.staffPositionArray
                                                : []
                                        "
                                        [(ngModel)]="item.staffPositionSelectedItemArray"
                                        [settings]="item.staffpositionDdlSettings"
                                        (onSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-staff-position',
                                                true
                                            )
                                        "
                                        (onDeSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-staff-position',
                                                true
                                            )
                                        "
                                        (onSelectAll)="onSelectAll($event)"
                                        (onDeSelectAll)="onDeSelectAll($event)"
                                        (onFilterSelectAll)="onSelectAll($event)"
                                        (onFilterDeSelectAll)="onDeSelectAll($event)"
                                        (onOpen)="
                                            setContainerHeight(
                                                'sub-filter-staff-position',
                                                true,
                                                item.staffPositionArray !== null
                                                    ? item.staffPositionArray.length
                                                    : 0,
                                                item.staffpositionDdlSettings.enableSearchFilter,
                                                item.staffpositionDdlSettings.enableCheckAll
                                            )
                                        "
                                        (onClose)="
                                            setContainerHeight(
                                                'sub-filter-staff-position',
                                                false,
                                                0
                                            )
                                        "
                                    >
                                    </angular2-multiselect>
                                </div>
                                <div
                                    id="sub-filter-{{ item.roleName }}"
                                    class="sub-filter"
                                    *ngIf="!item.isHidden && item.isEmployee"
                                    [style.pointer-events]="item.disableStatus"
                                >
                                    <div class="sub-filter-title" *ngIf="!item.isStaffPosition">
                                        {{ convertToCamelcase(item.roleNameDisplay) }}
                                    </div>
                                    <angular2-multiselect
                                        [data]="
                                            item.employeeArray !== null ? item.employeeArray : []
                                        "
                                        [(ngModel)]="item.employeeSelectedItemArray"
                                        [settings]="item.settings"
                                        (onSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-' + item.roleName
                                            )
                                        "
                                        (onDeSelect)="
                                            onSubFilterChange(
                                                $event,
                                                item,
                                                'sub-filter-' + item.roleName
                                            )
                                        "
                                        (onSelectAll)="onSelectAll($event)"
                                        (onDeSelectAll)="onDeSelectAll($event)"
                                        (onFilterSelectAll)="onSelectAll($event)"
                                        (onFilterDeSelectAll)="onDeSelectAll($event)"
                                        (onOpen)="
                                            setContainerHeight(
                                                'sub-filter-' + item.roleName,
                                                true,
                                                item.employeeArray !== null
                                                    ? item.employeeArray.length
                                                    : 0,
                                                item.settings.enableSearchFilter,
                                                item.settings.enableCheckAll
                                            )
                                        "
                                        (onClose)="
                                            setContainerHeight(
                                                'sub-filter-' + item.roleName,
                                                false,
                                                0
                                            )
                                        "
                                    >
                                    </angular2-multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="button-sets" id="save-apply-buttons">
                            <button
                                mat-button
                                class="button-no-background clearall-filter-button"
                                [disabled]="selectedLocations.length === 0"
                                (click)="clearAllUnappliedFilters()"
                            >
                                Clear All
                            </button>
                            <button
                                mat-button
                                class="save-button"
                                [disabled]="isSaveFilterBtnDisabled"
                                (click)="filterSaveBtnClick()"
                            >
                                SAVE&nbsp;AS
                            </button>
                            <button
                                mat-button
                                class="apply-button"
                                [disabled]="isApplyFilterBtnDisabled"
                                (click)="applyLocationsClick()"
                            >
                                APPLY
                            </button>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
    <div id="chip-dev" *ngIf="filterChipsToDisplay.length > 0">
        <span class="filterChips" *ngFor="let chip of filterChipsToDisplay">
            <mat-chip>
                <mat-chip-text>{{ chip.chipName }}</mat-chip-text>
                <mat-chip-icon
                    trailing
                    fontSet="fas"
                    fontIcon="fa-times-circle"
                    (click)="chipIconClick(chip)"
                    *ngIf="!readonly"
                ></mat-chip-icon>
            </mat-chip>
        </span>
        <span
            (click)="clearAllSelection()"
            class="clear-all-button"
            *ngIf="filterChipsToDisplay.length > 1 && !readonly"
            >Clear All</span
        >
    </div>
</div>
